import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';
import { RootObjectAvailableCredential } from '../types/allcredential';

export const useAvailableCredentials = () => {
    return useQuery<RootObjectAvailableCredential, Error>(['credentials'], async () => {
        const jsonResponse = await request({
            endpoint: 'credentials/available'
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    },{
    refetchOnWindowFocus: false,  
    });
};
